import { RegistrationRevision } from "@faro-lotv/service-wires";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type RevisionsState = {
  /** Array of all revisions of the project */
  revisions: RegistrationRevision[];
};

const initialState: RevisionsState = {
  revisions: [],
};

const revisionsSlice = createSlice({
  name: "revisions",
  initialState,
  reducers: {
    /**
     * Sets the revisions array in the store, making sure they're sorted by creation date (newest first).
     *
     * @param state The current state of the store
     * @param action Array of revisions to use
     */
    setRevisions(state, action: PayloadAction<RegistrationRevision[]>) {
      state.revisions = action.payload;
      state.revisions.sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );
    },
  },
});

export const revisionsReducer = revisionsSlice.reducer;

export const { setRevisions } = revisionsSlice.actions;
